import axios, { AxiosResponse } from 'axios';
import { CalibrationListItem } from 'views/bluviu-nutrition/features/calibrations/types/calibration-list-item.type';
import { UpdateCalibrationInformationRequest } from 'views/bluviu-nutrition/features/calibrations/types/update-calibration-information-request.type';

export const getCalibrations = async (globalSiteId: string): Promise<CalibrationListItem[]> => {
  const res = await axios.get<CalibrationListItem[]>(`/ewosapi/v1/calibration?globalSiteId=${globalSiteId}`);
  return res.data;
};

/**
 * Delete a multi cage calibration
 * @param globalSiteId
 * @param calibrationId
 * @returns
 */
export const deleteCalibration = async (globalSiteId: string, calibrationId: string): Promise<AxiosResponse> => {
  //   return CalibrationData;
  const res = await axios.delete<AxiosResponse>(
    `/ewosapi/v1/calibration/calibration?globalSiteId=${globalSiteId}&calibrationId=${calibrationId}`
  );

  return res.data;
};

export const putCalibrationGeneralInformation = async (
  globalSiteId: string,
  calibrationId: string,
  request: UpdateCalibrationInformationRequest
): Promise<AxiosResponse> => {
  const res = await axios.put<AxiosResponse>(
    `/ewosapi/v1/calibration?globalSiteId=${globalSiteId}&calibrationId=${calibrationId}`,
    request
  );

  return res.data;
};
